import { useState, useMemo } from 'react'
import {Search, X, ShoppingBag, Copy, Plus, Minus} from 'lucide-react'
import toast from 'react-hot-toast'
import { copiarTexto } from '@/utils/clipboard'

interface Produto {
  nome: string
  tamanho: string
  preco: number
  pv: number
  categoria: string
}

interface ItemSelecionado {
  produto: Produto
  quantidade: number
}

const CAT_1 = 'Óleos Essenciais Individuais 5ml e 15ml'
const CAT_2 = 'Aromas Naturais — Suplementos e Alimentos'
const CAT_3 = 'Óleos Essenciais e Mix Roll-On 5 e 10ml'
const CAT_4 = 'Mix de Óleos Essenciais'
const CAT_5 = 'dōTERRA Emotional Aromatherapy®'
const CAT_6 = 'Cuidados Pessoais'
const CAT_7 = 'Kits e Acessórios'

// Preços REGULARES de CONSUMIDOR — tabela oficial dōTERRA Lista de Preços P BR V39_030626
const PRODUTOS: Produto[] = [
  // ─── CAT_1 — Óleos Individuais ───────────────────────────────────────────
  { nome: 'Basil - Manjericão', tamanho: '15ml', preco: 307.00, pv: 27, categoria: CAT_1 },
  { nome: 'Bergamot - Bergamota', tamanho: '15ml', preco: 310.00, pv: 31, categoria: CAT_1 },
  { nome: 'Black Pepper - Pimenta-preta', tamanho: '5ml', preco: 250.00, pv: 24, categoria: CAT_1 },
  { nome: 'Black Spruce - Abeto-negro', tamanho: '5ml', preco: 180.00, pv: 18, categoria: CAT_1 },
  { nome: 'Breu Branco', tamanho: '5ml', preco: 325.00, pv: 32, categoria: CAT_1 },
  { nome: 'Cassia - Canela-cássia', tamanho: '15ml', preco: 200.00, pv: 20, categoria: CAT_1 },
  { nome: 'Cedarwood - Cedro', tamanho: '15ml', preco: 140.00, pv: 14, categoria: CAT_1 },
  { nome: 'Cilantro - Coentro', tamanho: '15ml', preco: 290.00, pv: 29, categoria: CAT_1 },
  { nome: 'Citronella - Citronela', tamanho: '15ml', preco: 123.00, pv: 12, categoria: CAT_1 },
  { nome: 'Clary Sage - Sálvia-esclareia', tamanho: '15ml', preco: 410.00, pv: 41, categoria: CAT_1 },
  { nome: 'Clove - Cravo', tamanho: '15ml', preco: 162.00, pv: 16, categoria: CAT_1 },
  { nome: 'Copaiba - Copaíba', tamanho: '15ml', preco: 320.00, pv: 40, categoria: CAT_1 },
  { nome: 'Coriander - Coentro', tamanho: '15ml', preco: 230.00, pv: 23, categoria: CAT_1 },
  { nome: 'Cypress - Cipreste', tamanho: '15ml', preco: 180.00, pv: 18, categoria: CAT_1 },
  { nome: 'Douglas Fir - Abeto de Douglas', tamanho: '5ml', preco: 223.00, pv: 22, categoria: CAT_1 },
  { nome: 'Erva Baleeira', tamanho: '5ml', preco: 298.00, pv: 31, categoria: CAT_1 },
  { nome: 'Fennel (Sweet) - Erva-doce', tamanho: '15ml', preco: 140.00, pv: 14, categoria: CAT_1 },
  { nome: 'Frankincense - Olíbano', tamanho: '15ml', preco: 648.00, pv: 64, categoria: CAT_1 },
  { nome: 'Geranium - Gerânio', tamanho: '15ml', preco: 318.00, pv: 31, categoria: CAT_1 },
  { nome: 'Ginger - Gengibre', tamanho: '15ml', preco: 358.00, pv: 33, categoria: CAT_1 },
  { nome: 'Grapefruit - Toranja', tamanho: '15ml', preco: 187.00, pv: 17, categoria: CAT_1 },
  { nome: 'Green Mandarin - Mandarina-verde', tamanho: '15ml', preco: 280.00, pv: 28, categoria: CAT_1 },
  { nome: 'Guaiacwood', tamanho: '15ml', preco: 170.00, pv: 16, categoria: CAT_1 },
  { nome: 'Hawaiian Sandalwood - Sândalo-havaiano', tamanho: '5ml', preco: 699.00, pv: 60, categoria: CAT_1 },
  { nome: 'Helichrysum - Sempre-viva', tamanho: '5ml', preco: 764.00, pv: 65, categoria: CAT_1 },
  { nome: 'Lavender - Lavanda', tamanho: '15ml', preco: 197.00, pv: 23, categoria: CAT_1 },
  { nome: 'Lemon - Limão-siciliano', tamanho: '15ml', preco: 115.00, pv: 11, categoria: CAT_1 },
  { nome: 'Lemon Eucalyptus - Eucalipto-limão', tamanho: '15ml', preco: 120.00, pv: 12, categoria: CAT_1 },
  { nome: 'Lemongrass - Capim-limão', tamanho: '15ml', preco: 110.00, pv: 11, categoria: CAT_1 },
  { nome: 'Lime - Limão', tamanho: '15ml', preco: 143.00, pv: 14, categoria: CAT_1 },
  { nome: 'Madagascar Vanilla', tamanho: '5ml', preco: 345.00, pv: 34, categoria: CAT_1 },
  { nome: 'Mālama', tamanho: '15ml', preco: 242.00, pv: 23, categoria: CAT_1 },
  { nome: 'Marjoram - Manjerona', tamanho: '15ml', preco: 213.00, pv: 21, categoria: CAT_1 },
  { nome: 'Melaleuca - Tea Tree', tamanho: '15ml', preco: 210.00, pv: 21, categoria: CAT_1 },
  { nome: 'Melissa', tamanho: '5ml', preco: 895.00, pv: 76, categoria: CAT_1 },
  { nome: 'Myrrh - Mirra', tamanho: '15ml', preco: 655.00, pv: 51, categoria: CAT_1 },
  { nome: 'Oregano - Orégano', tamanho: '15ml', preco: 230.00, pv: 23, categoria: CAT_1 },
  { nome: 'Patchouli', tamanho: '15ml', preco: 293.00, pv: 29, categoria: CAT_1 },
  { nome: 'Peppermint - Hortelã-pimenta', tamanho: '15ml', preco: 184.00, pv: 23, categoria: CAT_1 },
  { nome: 'Petitgrain', tamanho: '15ml', preco: 230.00, pv: 23, categoria: CAT_1 },
  { nome: 'Roman Chamomile - Camomila-romana', tamanho: '5ml', preco: 510.00, pv: 51, categoria: CAT_1 },
  { nome: 'Rosemary - Alecrim', tamanho: '15ml', preco: 165.00, pv: 16, categoria: CAT_1 },
  { nome: 'Siberian Fir - Pinheiro-siberiano', tamanho: '15ml', preco: 190.00, pv: 19, categoria: CAT_1 },
  { nome: 'Spearmint - Hortelã-verde', tamanho: '15ml', preco: 290.00, pv: 29, categoria: CAT_1 },
  { nome: 'Spikenard - Nardo', tamanho: '5ml', preco: 560.00, pv: 56, categoria: CAT_1 },
  { nome: 'Tangerine - Tangerina', tamanho: '15ml', preco: 170.00, pv: 16, categoria: CAT_1 },
  { nome: 'Thyme - Tomilho', tamanho: '15ml', preco: 292.00, pv: 28, categoria: CAT_1 },
  { nome: 'Vetiver', tamanho: '15ml', preco: 512.00, pv: 41, categoria: CAT_1 },
  { nome: 'Wild Orange - Laranja-selvagem', tamanho: '15ml', preco: 120.00, pv: 12, categoria: CAT_1 },
  { nome: 'Wintergreen', tamanho: '15ml', preco: 180.00, pv: 18, categoria: CAT_1 },
  { nome: 'Ylang Ylang', tamanho: '5ml', preco: 123.00, pv: 12, categoria: CAT_1 },
  { nome: 'Ylang Ylang', tamanho: '15ml', preco: 373.00, pv: 37, categoria: CAT_1 },
  // ─── CAT_2 — Suplementos e Alimentos ─────────────────────────────────────
  { nome: 'Adaptiv® Pastilhas', tamanho: '60 pastilhas', preco: 308.00, pv: 31, categoria: CAT_2 },
  { nome: 'Basil - Manjericão (Ingestão)', tamanho: '5ml', preco: 103.00, pv: 9, categoria: CAT_2 },
  { nome: 'dōTERRA Beauty Power™ Collagen Elixir', tamanho: '210g', preco: 264.00, pv: 35, categoria: CAT_2 },
  { nome: 'Bergamot - Bergamota (Ingestão)', tamanho: '5ml', preco: 123.00, pv: 12, categoria: CAT_2 },
  { nome: 'Black Pepper - Pimenta-preta (Ingestão)', tamanho: '5ml', preco: 250.00, pv: 24, categoria: CAT_2 },
  { nome: 'Cardamom - Cardamomo (Ingestão)', tamanho: '5ml', preco: 272.00, pv: 29, categoria: CAT_2 },
  { nome: 'Cassia - Canela-cássia (Ingestão)', tamanho: '5ml', preco: 80.00, pv: 8, categoria: CAT_2 },
  { nome: 'Cilantro - Coentro (Ingestão)', tamanho: '5ml', preco: 93.00, pv: 9, categoria: CAT_2 },
  { nome: 'Cinnamon Bark', tamanho: '5ml', preco: 252.00, pv: 24, categoria: CAT_2 },
  { nome: 'Clary Sage - Sálvia-esclareia (Ingestão)', tamanho: '5ml', preco: 163.00, pv: 17, categoria: CAT_2 },
  { nome: 'Clove - Cravo (Ingestão)', tamanho: '5ml', preco: 73.00, pv: 7, categoria: CAT_2 },
  { nome: 'Copaiba - Copaíba (Ingestão)', tamanho: '5ml', preco: 160.00, pv: 16, categoria: CAT_2 },
  { nome: 'Copaiba Softgels', tamanho: '60 pastilhas', preco: 252.00, pv: 28, categoria: CAT_2 },
  { nome: 'Coriander - Coentro (Ingestão)', tamanho: '5ml', preco: 87.00, pv: 9, categoria: CAT_2 },
  { nome: 'DDR Prime® Pastilha', tamanho: '90 pastilhas', preco: 325.00, pv: 30, categoria: CAT_2 },
  { nome: 'dōTERRA Creatina Lifepower', tamanho: '105g', preco: 239.00, pv: 27, categoria: CAT_2 },
  { nome: 'Fennel (Sweet) - Erva-doce (Ingestão)', tamanho: '5ml', preco: 63.00, pv: 6, categoria: CAT_2 },
  { nome: 'Frankincense - Olíbano (Ingestão)', tamanho: '5ml', preco: 270.00, pv: 27, categoria: CAT_2 },
  { nome: 'Geranium - Gerânio (Ingestão)', tamanho: '5ml', preco: 125.00, pv: 12, categoria: CAT_2 },
  { nome: 'Ginger - Gengibre (Ingestão)', tamanho: '5ml', preco: 128.00, pv: 11, categoria: CAT_2 },
  { nome: 'Grapefruit - Toranja (Ingestão)', tamanho: '5ml', preco: 73.00, pv: 6, categoria: CAT_2 },
  { nome: 'Green Mandarin - Mandarina-verde (Ingestão)', tamanho: '5ml', preco: 98.00, pv: 10, categoria: CAT_2 },
  { nome: 'Juniper Berry - Zimbro (Ingestão)', tamanho: '5ml', preco: 210.00, pv: 21, categoria: CAT_2 },
  { nome: 'Lavender - Lavanda (Ingestão)', tamanho: '5ml', preco: 103.00, pv: 10, categoria: CAT_2 },
  { nome: 'Lemon - Limão-siciliano (Ingestão)', tamanho: '5ml', preco: 48.00, pv: 4, categoria: CAT_2 },
  { nome: 'Lemongrass - Capim-limão (Ingestão)', tamanho: '5ml', preco: 43.00, pv: 4, categoria: CAT_2 },
  { nome: 'dōTERRA Lifeshot', tamanho: '1 litro', preco: 208.00, pv: 24, categoria: CAT_2 },
  { nome: 'dōTERRA Lifeshot Pack com 2', tamanho: '2 litros', preco: 420.00, pv: 52, categoria: CAT_2 },
  { nome: 'Lime - Limão (Ingestão)', tamanho: '5ml', preco: 58.00, pv: 5, categoria: CAT_2 },
  { nome: 'Marjoram - Manjerona (Ingestão)', tamanho: '5ml', preco: 88.00, pv: 8, categoria: CAT_2 },
  { nome: 'MetaPWR™ Aroma Natural de Especiarias', tamanho: '15ml', preco: 298.00, pv: 27, categoria: CAT_2 },
  { nome: 'MetaPWR™ Pastilhas', tamanho: '90 pastilhas', preco: 315.00, pv: 28, categoria: CAT_2 },
  { nome: 'Myrrh - Mirra (Ingestão)', tamanho: '5ml', preco: 248.00, pv: 19, categoria: CAT_2 },
  { nome: 'On Guard® (Ingestão)', tamanho: '5ml', preco: 140.00, pv: 14, categoria: CAT_2 },
  { nome: 'On Guard® Beadlets', tamanho: '125 pastilhas', preco: 155.00, pv: 15, categoria: CAT_2 },
  { nome: 'On Guard®+ Pastilhas', tamanho: '60 pastilhas', preco: 248.00, pv: 22, categoria: CAT_2 },
  { nome: 'Oregano - Orégano (Ingestão)', tamanho: '5ml', preco: 100.00, pv: 10, categoria: CAT_2 },
  { nome: 'Patchouli (Ingestão)', tamanho: '5ml', preco: 113.00, pv: 11, categoria: CAT_2 },
  { nome: 'Peppermint - Hortelã-pimenta (Ingestão)', tamanho: '5ml', preco: 92.00, pv: 9, categoria: CAT_2 },
  { nome: 'Peppermint Beadlets', tamanho: '125 pastilhas', preco: 140.00, pv: 12, categoria: CAT_2 },
  { nome: 'Petitgrain (Ingestão)', tamanho: '5ml', preco: 92.00, pv: 9, categoria: CAT_2 },
  { nome: 'Pink Pepper - Pimenta-rosa (Ingestão)', tamanho: '5ml', preco: 230.00, pv: 20, categoria: CAT_2 },
  { nome: 'Rosemary - Alecrim (Ingestão)', tamanho: '5ml', preco: 67.00, pv: 6, categoria: CAT_2 },
  { nome: 'Siberian Fir (Ingestão)', tamanho: '5ml', preco: 70.00, pv: 7, categoria: CAT_2 },
  { nome: 'Spearmint (Ingestão)', tamanho: '5ml', preco: 98.00, pv: 10, categoria: CAT_2 },
  { nome: 'Tangerine - Tangerina (Ingestão)', tamanho: '5ml', preco: 70.00, pv: 7, categoria: CAT_2 },
  { nome: 'Thyme - Tomilho (Ingestão)', tamanho: '5ml', preco: 123.00, pv: 11, categoria: CAT_2 },
  { nome: 'Turmeric - Cúrcuma (Ingestão)', tamanho: '15ml', preco: 292.00, pv: 28, categoria: CAT_2 },
  { nome: 'Turmeric Pastilhas', tamanho: '60 pastilhas', preco: 248.00, pv: 24, categoria: CAT_2 },
  { nome: 'Vetiver (Ingestão)', tamanho: '5ml', preco: 217.00, pv: 18, categoria: CAT_2 },
  { nome: 'VM Complex', tamanho: '120 cápsulas', preco: 248.00, pv: 28, categoria: CAT_2 },
  { nome: 'Wild Orange - Laranja-selvagem (Ingestão)', tamanho: '5ml', preco: 43.00, pv: 4, categoria: CAT_2 },
  { nome: 'Zendocrine® (Ingestão)', tamanho: '5ml', preco: 98.00, pv: 9, categoria: CAT_2 },
  { nome: 'Zendocrine® Pastilhas', tamanho: '60 pastilhas', preco: 224.00, pv: 21, categoria: CAT_2 },
  { nome: 'ZenGest® (Ingestão)', tamanho: '5ml', preco: 140.00, pv: 11, categoria: CAT_2 },
  { nome: 'ZenGest® Pastilhas', tamanho: '60 pastilhas', preco: 215.00, pv: 20, categoria: CAT_2 },
  // ─── CAT_3 — Roll-On ─────────────────────────────────────────────────────
  { nome: 'Adaptiv® Touch', tamanho: '10ml', preco: 200.00, pv: 20, categoria: CAT_3 },
  { nome: 'dōTERRA Brave®', tamanho: '10ml', preco: 220.00, pv: 22, categoria: CAT_3 },
  { nome: 'dōTERRA Breathe® Touch', tamanho: '10ml', preco: 150.00, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Calmer®', tamanho: '10ml', preco: 200.00, pv: 20, categoria: CAT_3 },
  { nome: 'Clarycalm®', tamanho: '10ml', preco: 292.00, pv: 28, categoria: CAT_3 },
  { nome: 'Copaiba Touch', tamanho: '10ml', preco: 230.00, pv: 23, categoria: CAT_3 },
  { nome: 'dōTERRA Deep Blue® Touch', tamanho: '10ml', preco: 430.00, pv: 42, categoria: CAT_3 },
  { nome: 'dōTERRA Frankincense Touch', tamanho: '10ml', preco: 500.00, pv: 50, categoria: CAT_3 },
  { nome: 'Helichrysum Touch', tamanho: '10ml', preco: 530.00, pv: 50, categoria: CAT_3 },
  { nome: 'Hope™ Touch', tamanho: '10ml', preco: 208.00, pv: 20, categoria: CAT_3 },
  { nome: 'InTune®', tamanho: '10ml', preco: 337.00, pv: 32, categoria: CAT_3 },
  { nome: 'Jasmine Touch', tamanho: '10ml', preco: 393.00, pv: 39, categoria: CAT_3 },
  { nome: 'Lavender Touch', tamanho: '10ml', preco: 160.00, pv: 16, categoria: CAT_3 },
  { nome: 'Melaleuca Touch', tamanho: '10ml', preco: 140.00, pv: 14, categoria: CAT_3 },
  { nome: 'On Guard® Touch', tamanho: '10ml', preco: 240.00, pv: 24, categoria: CAT_3 },
  { nome: 'Oregano Touch', tamanho: '10ml', preco: 150.00, pv: 15, categoria: CAT_3 },
  { nome: 'PastTense®', tamanho: '10ml', preco: 200.00, pv: 20, categoria: CAT_3 },
  { nome: 'Peppermint Touch', tamanho: '10ml', preco: 150.00, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Rescuer®', tamanho: '10ml', preco: 160.00, pv: 16, categoria: CAT_3 },
  { nome: 'Rose Touch', tamanho: '10ml', preco: 650.00, pv: 65, categoria: CAT_3 },
  { nome: 'dōTERRA Steady®', tamanho: '10ml', preco: 160.00, pv: 16, categoria: CAT_3 },
  { nome: 'dōTERRA Stronger®', tamanho: '10ml', preco: 150.00, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Tamer®', tamanho: '10ml', preco: 150.00, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Thinker®', tamanho: '10ml', preco: 170.00, pv: 17, categoria: CAT_3 },
  { nome: 'Vetiver Touch', tamanho: '10ml', preco: 330.00, pv: 33, categoria: CAT_3 },
  { nome: 'Whisper™ Touch', tamanho: '5ml', preco: 150.00, pv: 15, categoria: CAT_3 },
  { nome: 'ZenGest® Touch', tamanho: '10ml', preco: 230.00, pv: 23, categoria: CAT_3 },
  // ─── CAT_4 — Mix de Óleos ─────────────────────────────────────────────────
  { nome: 'Adaptiv®', tamanho: '15ml', preco: 378.00, pv: 37, categoria: CAT_4 },
  { nome: 'Air-X™', tamanho: '15ml', preco: 232.00, pv: 23, categoria: CAT_4 },
  { nome: 'dōTERRA AromaTouch®', tamanho: '15ml', preco: 290.00, pv: 29, categoria: CAT_4 },
  { nome: 'dōTERRA Balance®', tamanho: '15ml', preco: 210.00, pv: 21, categoria: CAT_4 },
  { nome: 'dōTERRA Breathe®', tamanho: '15ml', preco: 230.00, pv: 23, categoria: CAT_4 },
  { nome: 'Citrus Bliss®', tamanho: '15ml', preco: 180.00, pv: 17, categoria: CAT_4 },
  { nome: 'DDR Prime®', tamanho: '15ml', preco: 300.00, pv: 29, categoria: CAT_4 },
  { nome: 'dōTERRA Deep Blue®', tamanho: '5ml', preco: 288.00, pv: 36, categoria: CAT_4 },
  { nome: 'dōTERRA Serenity®', tamanho: '15ml', preco: 340.00, pv: 34, categoria: CAT_4 },
  { nome: 'dōTERRA Elevation®', tamanho: '15ml', preco: 465.00, pv: 42, categoria: CAT_4 },
  { nome: 'Eucalyptus (Blend)', tamanho: '15ml', preco: 192.00, pv: 19, categoria: CAT_4 },
  { nome: 'Forest Bathing', tamanho: '15ml', preco: 315.00, pv: 28, categoria: CAT_4 },
  { nome: 'dōTERRA Hygge™', tamanho: '15ml', preco: 350.00, pv: 33, categoria: CAT_4 },
  { nome: 'On Guard®', tamanho: '15ml', preco: 360.00, pv: 36, categoria: CAT_4 },
  { nome: 'dōTERRA Purify®', tamanho: '15ml', preco: 200.00, pv: 20, categoria: CAT_4 },
  { nome: 'Sunny Citrus', tamanho: '15ml', preco: 190.00, pv: 16, categoria: CAT_4 },
  { nome: 'Supermint', tamanho: '15ml', preco: 242.00, pv: 25, categoria: CAT_4 },
  { nome: 'TerraShield®', tamanho: '15ml', preco: 110.00, pv: 11, categoria: CAT_4 },
  { nome: 'Zendocrine®', tamanho: '15ml', preco: 247.00, pv: 24, categoria: CAT_4 },
  { nome: 'ZenGest®', tamanho: '15ml', preco: 353.00, pv: 35, categoria: CAT_4 },
  // ─── CAT_5 — Emotional Aromatherapy ──────────────────────────────────────
  { nome: 'dōTERRA Cheer®', tamanho: '5ml', preco: 260.00, pv: 26, categoria: CAT_5 },
  { nome: 'dōTERRA Cheer® Touch Roll-On', tamanho: '10ml', preco: 160.00, pv: 16, categoria: CAT_5 },
  { nome: 'dōTERRA Console® Touch Roll-On', tamanho: '10ml', preco: 240.00, pv: 24, categoria: CAT_5 },
  { nome: 'Kit dōTERRA Touch Emotional Aromatherapy®', tamanho: 'Caixa', preco: 1002.00, pv: 100, categoria: CAT_5 },
  { nome: 'dōTERRA Forgive®', tamanho: '5ml', preco: 210.00, pv: 21, categoria: CAT_5 },
  { nome: 'dōTERRA Forgive® Touch Roll-On', tamanho: '10ml', preco: 135.00, pv: 13, categoria: CAT_5 },
  { nome: 'dōTERRA Motivate®', tamanho: '5ml', preco: 240.00, pv: 24, categoria: CAT_5 },
  { nome: 'dōTERRA Motivate® Touch Roll-On', tamanho: '10ml', preco: 150.00, pv: 15, categoria: CAT_5 },
  { nome: 'dōTERRA Passion®', tamanho: '5ml', preco: 279.00, pv: 28, categoria: CAT_5 },
  { nome: 'dōTERRA Passion® Touch Roll-On', tamanho: '10ml', preco: 247.00, pv: 27, categoria: CAT_5 },
  { nome: 'dōTERRA Peace®', tamanho: '5ml', preco: 310.00, pv: 31, categoria: CAT_5 },
  { nome: 'dōTERRA Peace® Touch Roll-On', tamanho: '10ml', preco: 200.00, pv: 20, categoria: CAT_5 },
  // ─── CAT_6 — Cuidados Pessoais ────────────────────────────────────────────
  { nome: 'Breathe Balm Stick', tamanho: '13,5g', preco: 148.00, pv: 14, categoria: CAT_6 },
  { nome: 'Citrus Bliss Loção para as Mãos', tamanho: '75ml', preco: 97.00, pv: 9, categoria: CAT_6 },
  { nome: 'Conditioner Hair Care Condicionador', tamanho: '500ml', preco: 212.00, pv: 18, categoria: CAT_6 },
  { nome: 'Conditioner Leave-in Condicionador Leave-in', tamanho: '237ml', preco: 198.00, pv: 15, categoria: CAT_6 },
  { nome: 'Correct-X® Gel Reparador', tamanho: '15ml', preco: 140.00, pv: 12, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Rub', tamanho: '120ml', preco: 297.00, pv: 33, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Rub Travel Pack', tamanho: '5 bisnagas', preco: 80.00, pv: 5, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Stick + Copaíba', tamanho: '30g', preco: 185.00, pv: 23, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Esfoliante para o Corpo', tamanho: '226g', preco: 211.00, pv: 16, categoria: CAT_6 },
  { nome: 'Óleo de Coco Fracionado', tamanho: '115ml', preco: 142.00, pv: 11, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Loção para Mãos e Corpo', tamanho: '200ml', preco: 149.00, pv: 13, categoria: CAT_6 },
  { nome: 'HD Clear™ Roll-On', tamanho: '10ml', preco: 180.00, pv: 18, categoria: CAT_6 },
  { nome: 'Lavender Fields™ Body Splash', tamanho: '100ml', preco: 191.00, pv: 18, categoria: CAT_6 },
  { nome: 'On Guard® Creme Dental Natural', tamanho: '125g', preco: 93.00, pv: 5, categoria: CAT_6 },
  { nome: 'On Guard® Creme Dental Travel Pack', tamanho: '5 bisnagas', preco: 25.00, pv: 1, categoria: CAT_6 },
  { nome: 'Shampoo Protetor', tamanho: '500ml', preco: 193.00, pv: 18, categoria: CAT_6 },
  { nome: 'dōTERRA Pūre™ Femme Eau de Parfum', tamanho: '60ml', preco: 500.00, pv: 50, categoria: CAT_6 },
  { nome: 'dōTERRA Pūr™ Homme Eau de Parfum', tamanho: '60ml', preco: 500.00, pv: 50, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Sabonete Hidratante', tamanho: '250ml', preco: 131.00, pv: 10, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Manteiga Hidratante Corporal', tamanho: '198g', preco: 224.00, pv: 14, categoria: CAT_6 },
  { nome: 'Salubelle™', tamanho: '10ml', preco: 725.00, pv: 68, categoria: CAT_6 },
  { nome: 'Veráge® Solução de Limpeza Facial', tamanho: '60ml', preco: 260.00, pv: 21, categoria: CAT_6 },
  { nome: 'Verage Hidratante Facial', tamanho: '30ml', preco: 290.00, pv: 27, categoria: CAT_6 },
  { nome: 'Verage Tônico Facial', tamanho: '50ml', preco: 289.00, pv: 22, categoria: CAT_6 },
  { nome: 'Veráge Collection', tamanho: '', preco: 899.00, pv: 67, categoria: CAT_6 },
  { nome: 'Veráge® Creme Hidratante', tamanho: '48g', preco: 303.00, pv: 32, categoria: CAT_6 },
  { nome: 'Yarrow | Pom', tamanho: '15ml', preco: 470.00, pv: 47, categoria: CAT_6 },
  { nome: 'Yarrow | Pom - Ativo Botânico Duo', tamanho: '30ml', preco: 930.00, pv: 93, categoria: CAT_6 },
  // ─── CAT_7 — Kits e Acessórios ────────────────────────────────────────────
  { nome: 'Kit Técnica dōTERRA® AromaTouch® com Difusor', tamanho: 'Caixa', preco: 1633.00, pv: 115, categoria: CAT_7 },
  { nome: 'Kit Técnica dōTERRA AromaTouch®', tamanho: 'Caixa', preco: 1040.00, pv: 104, categoria: CAT_7 },
  { nome: 'Blooming Trio Kit', tamanho: '', preco: 375.00, pv: 33, categoria: CAT_7 },
  { nome: 'Difusor de Parede Myst', tamanho: '', preco: 495.00, pv: 10, categoria: CAT_7 },
  { nome: 'dōTERRA Dawn® Umidificador Aromático', tamanho: '', preco: 797.00, pv: 15, categoria: CAT_7 },
  { nome: "dōTERRA Collector's Kit Box", tamanho: '', preco: 1189.00, pv: 135, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Conforto', tamanho: '', preco: 380.00, pv: 48, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Equilíbrio', tamanho: '', preco: 397.00, pv: 46, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Inspire', tamanho: '', preco: 357.00, pv: 46, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Revitalize', tamanho: '', preco: 351.00, pv: 48, categoria: CAT_7 },
  { nome: 'dōTERRA® Brasil Living Kit', tamanho: 'Caixa', preco: 960.00, pv: 120, categoria: CAT_7 },
  { nome: 'dōTERRA® Construa seu Legado Kit', tamanho: '', preco: 1600.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA® Culinária Essencial', tamanho: 'Caixa', preco: 892.00, pv: 65, categoria: CAT_7 },
  { nome: 'dōTERRA® Culinária Essencial Sem Livro', tamanho: 'Caixa', preco: 717.00, pv: 55, categoria: CAT_7 },
  { nome: 'dōTERRA® Essencial Para o Lar (Pebble)', tamanho: 'Caixa', preco: 2517.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA® Essencial Para o Lar (Petal)', tamanho: 'Caixa', preco: 2517.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA® Kids Kit', tamanho: '', preco: 1022.00, pv: 89, categoria: CAT_7 },
  { nome: 'dōTERRA® Kit de Apresentação', tamanho: '', preco: 187.00, pv: 12, categoria: CAT_7 },
  { nome: 'dōTERRA® Kit Início Rápido', tamanho: '', preco: 800.00, pv: 100, categoria: CAT_7 },
  { nome: 'dōTERRA® Kit Primeiros Cuidados', tamanho: '', preco: 1497.00, pv: 132, categoria: CAT_7 },
  { nome: 'dōTERRA® Wooden Box', tamanho: '', preco: 105.00, pv: 0, categoria: CAT_7 },
  { nome: 'Gênesis Performance', tamanho: '', preco: 787.00, pv: 100, categoria: CAT_7 },
  { nome: 'Gênesis Beauty Fit', tamanho: '', preco: 1000.00, pv: 100, categoria: CAT_7 },
  { nome: 'Kit com Difusor Pebble™', tamanho: '', preco: 498.00, pv: 13, categoria: CAT_7 },
  { nome: 'Livro Culinária Essencial', tamanho: '', preco: 150.00, pv: 10, categoria: CAT_7 },
  { nome: 'Petal 2.0 Kit', tamanho: '', preco: 665.00, pv: 30, categoria: CAT_7 },
]

const normalizar = (s: string) =>
  s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

const chaveProduto = (p: Produto) => `${p.nome}__${p.tamanho}`

const fmtBR = (v: number) =>
  v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export default function VendaAvulsa() {
  const [busca, setBusca] = useState('')
  const [itens, setItens] = useState<ItemSelecionado[]>([])

  const resultados = useMemo(() => {
    const termo = normalizar(busca.trim())
    if (!termo) return []
    return PRODUTOS.filter(
      p => normalizar(p.nome).includes(termo) || normalizar(p.tamanho).includes(termo)
    ).slice(0, 30)
  }, [busca])

  const estaNoCarrinho = (p: Produto) =>
    itens.some(i => chaveProduto(i.produto) === chaveProduto(p))

  const toggleProduto = (p: Produto) => {
    setItens(prev => {
      const existe = prev.some(i => chaveProduto(i.produto) === chaveProduto(p))
      if (existe) return prev.filter(i => chaveProduto(i.produto) !== chaveProduto(p))
      return [...prev, { produto: p, quantidade: 1 }]
    })
  }

  const removerItem = (p: Produto) => {
    setItens(prev => prev.filter(i => chaveProduto(i.produto) !== chaveProduto(p)))
  }

  const alterarQuantidade = (p: Produto, delta: number) => {
    setItens(prev =>
      prev.map(i => {
        if (chaveProduto(i.produto) !== chaveProduto(p)) return i
        return { ...i, quantidade: Math.max(1, i.quantidade + delta) }
      })
    )
  }

  const setQuantidade = (p: Produto, valor: string) => {
    const num = parseInt(valor, 10)
    if (isNaN(num)) return
    setItens(prev =>
      prev.map(i =>
        chaveProduto(i.produto) === chaveProduto(p) ? { ...i, quantidade: Math.max(1, num) } : i
      )
    )
  }

  const totalPV = itens.reduce((acc, i) => acc + i.produto.pv * i.quantidade, 0)
  const totalValor = itens.reduce((acc, i) => acc + i.produto.preco * i.quantidade, 0)

  const montarOrcamento = (): string => {
    let texto = `*ORÇAMENTO dōTERRA*\n\n`
    itens.forEach(({ produto: p, quantidade }) => {
      const tam = p.tamanho ? ` ${p.tamanho}` : ''
      const subtotal = p.preco * quantidade
      if (quantidade > 1) {
        texto += `- ${p.nome}${tam} (x${quantidade}) → R$ ${fmtBR(subtotal)}\n`
      } else {
        texto += `- ${p.nome}${tam} → R$ ${fmtBR(subtotal)}\n`
      }
    })
    texto += `\n*Total de PV:* ${totalPV}\n`
    texto += `*Total:* R$ ${fmtBR(totalValor)}`
    return texto
  }

  const copiarOrcamento = async () => {
    if (itens.length === 0) {
      toast.error('Selecione pelo menos um produto')
      return
    }
    try {
      await copiarTexto(montarOrcamento())
      toast.success('Orçamento copiado!')
    } catch {
      toast.error('Erro ao copiar')
    }
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* Cabeçalho */}
      <div>
        <h2 className="text-2xl font-cormorant font-semibold text-texto-escuro mb-1 flex items-center gap-2">
          <ShoppingBag className="w-6 h-6 text-verde-escuro" />
          Venda Avulsa
        </h2>
        <p className="text-sm text-texto-suave">
          Preços de consumidor para vendas pontuais. Gere um orçamento rápido para enviar pelo WhatsApp.
        </p>
      </div>

      {/* Aviso */}
      <div
        className="flex items-start gap-3 px-4 py-3 rounded-xl text-sm"
        style={{ backgroundColor: '#FEF3C7', border: '1px solid #FCD34D', color: '#78350F' }}
      >
        <span className="text-base flex-shrink-0">💡</span>
        <span>
          Esta calculadora usa <strong>preços de consumidor</strong> dōTERRA.
          Frete, taxa de adesão e formas de pagamento são informados separadamente pelo(a) consultor(a).
        </span>
      </div>

      {/* Campo de busca */}
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#B08968' }} />
        <input
          type="text"
          value={busca}
          onChange={e => setBusca(e.target.value)}
          placeholder="Digite o nome do produto..."
          className="w-full pl-12 pr-4 py-3 rounded-xl border-2 focus:outline-none focus:border-[#52B788]"
          style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF', color: '#2C2C2A' }}
        />
      </div>

      {/* Resultados da busca */}
      {busca.trim() && (
        <div className="rounded-xl border overflow-hidden" style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF' }}>
          {resultados.length === 0 ? (
            <div className="p-4 text-sm" style={{ color: '#5F5E5A' }}>
              Nenhum produto encontrado.
            </div>
          ) : (
            <ul className="divide-y" style={{ borderColor: '#EDE0D4' }}>
              {resultados.map(p => {
                const marcado = estaNoCarrinho(p)
                return (
                  <li
                    key={chaveProduto(p)}
                    onClick={() => toggleProduto(p)}
                    className="flex items-center gap-3 p-3 cursor-pointer hover:bg-[#F8F4EF] transition-colors"
                  >
                    <input
                      type="checkbox"
                      checked={marcado}
                      onChange={() => toggleProduto(p)}
                      onClick={e => e.stopPropagation()}
                      className="w-5 h-5 accent-[#2D6A4F] cursor-pointer flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium" style={{ color: '#2C2C2A' }}>
                        {p.nome}
                        {p.tamanho && (
                          <span className="ml-2 text-sm font-normal" style={{ color: '#5F5E5A' }}>
                            {p.tamanho}
                          </span>
                        )}
                      </div>
                      <div className="text-xs" style={{ color: '#B08968' }}>{p.categoria}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold" style={{ color: '#2D6A4F' }}>
                        R$ {fmtBR(p.preco)}
                      </div>
                      <div className="text-xs" style={{ color: '#5F5E5A' }}>
                        {p.pv > 0 ? `${p.pv} PV` : 'sem PV'}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )}

      {/* Produtos selecionados */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <ShoppingBag className="w-5 h-5" style={{ color: '#2D6A4F' }} />
          <h4 className="font-semibold" style={{ color: '#2D6A4F' }}>
            Produtos selecionados {itens.length > 0 && `(${itens.length})`}
          </h4>
        </div>

        {itens.length === 0 ? (
          <div
            className="p-4 rounded-xl text-sm text-center"
            style={{ backgroundColor: '#F8F4EF', color: '#5F5E5A', border: '1px dashed #EDE0D4' }}
          >
            Nenhum produto selecionado. Use a busca acima para adicionar.
          </div>
        ) : (
          <div className="rounded-xl border overflow-hidden" style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF' }}>
            {/* Cabeçalho da tabela — desktop */}
            <div
              className="hidden sm:grid text-xs font-semibold px-4 py-2"
              style={{
                gridTemplateColumns: '1fr 130px 90px 60px 90px 60px 36px',
                backgroundColor: '#F8F4EF',
                color: '#B08968',
                borderBottom: '1px solid #EDE0D4',
              }}
            >
              <span>Produto</span>
              <span className="text-center">Quantidade</span>
              <span className="text-right">Valor unit.</span>
              <span className="text-right">PV unit.</span>
              <span className="text-right">Subtotal</span>
              <span className="text-right">PV subtotal</span>
              <span></span>
            </div>

            <ul className="divide-y" style={{ borderColor: '#EDE0D4' }}>
              {itens.map(({ produto: p, quantidade }) => {
                const subtotal = p.preco * quantidade
                const pvSubtotal = p.pv * quantidade
                return (
                  <li key={chaveProduto(p)} className="px-4 py-3">
                    {/* Mobile */}
                    <div className="sm:hidden space-y-2">
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex-1 min-w-0">
                          <div className="font-medium text-sm" style={{ color: '#2C2C2A' }}>
                            {p.nome}
                            {p.tamanho && (
                              <span className="ml-1 font-normal" style={{ color: '#5F5E5A' }}>
                                {p.tamanho}
                              </span>
                            )}
                          </div>
                          <div className="text-xs mt-0.5" style={{ color: '#B08968' }}>{p.categoria}</div>
                        </div>
                        <button
                          onClick={() => removerItem(p)}
                          className="p-1.5 rounded-full hover:bg-red-50 transition-colors flex-shrink-0"
                        >
                          <X className="w-4 h-4 text-red-500" />
                        </button>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-1">
                          <button
                            onClick={() => alterarQuantidade(p, -1)}
                            className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#F8F4EF]"
                            style={{ borderColor: '#EDE0D4' }}
                          >
                            <Minus className="w-3 h-3" style={{ color: '#5F5E5A' }} />
                          </button>
                          <input
                            type="number"
                            min={1}
                            value={quantidade}
                            onChange={e => setQuantidade(p, e.target.value)}
                            className="w-10 text-center text-sm font-semibold border rounded-lg py-0.5 focus:outline-none focus:border-[#52B788]"
                            style={{ borderColor: '#EDE0D4', color: '#2C2C2A' }}
                          />
                          <button
                            onClick={() => alterarQuantidade(p, 1)}
                            className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#D8F3DC]"
                            style={{ borderColor: '#52B788', color: '#2D6A4F' }}
                          >
                            <Plus className="w-3 h-3" />
                          </button>
                        </div>
                        <div className="text-right text-sm">
                          <div className="font-bold" style={{ color: '#2D6A4F' }}>
                            R$ {fmtBR(subtotal)}
                          </div>
                          <div className="text-xs" style={{ color: '#5F5E5A' }}>{pvSubtotal} PV</div>
                        </div>
                      </div>
                    </div>

                    {/* Desktop */}
                    <div
                      className="hidden sm:grid items-center gap-3"
                      style={{ gridTemplateColumns: '1fr 130px 90px 60px 90px 60px 36px' }}
                    >
                      <div className="min-w-0">
                        <div className="font-medium text-sm truncate" style={{ color: '#2C2C2A' }}>
                          {p.nome}
                          {p.tamanho && (
                            <span className="ml-1 font-normal text-xs" style={{ color: '#5F5E5A' }}>
                              {p.tamanho}
                            </span>
                          )}
                        </div>
                        <div className="text-xs truncate" style={{ color: '#B08968' }}>{p.categoria}</div>
                      </div>
                      <div className="flex items-center justify-center gap-1">
                        <button
                          onClick={() => alterarQuantidade(p, -1)}
                          className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#F8F4EF]"
                          style={{ borderColor: '#EDE0D4' }}
                        >
                          <Minus className="w-3 h-3" style={{ color: '#5F5E5A' }} />
                        </button>
                        <input
                          type="number"
                          min={1}
                          value={quantidade}
                          onChange={e => setQuantidade(p, e.target.value)}
                          className="w-12 text-center text-sm font-semibold border rounded-lg py-0.5 focus:outline-none focus:border-[#52B788]"
                          style={{ borderColor: '#EDE0D4', color: '#2C2C2A' }}
                        />
                        <button
                          onClick={() => alterarQuantidade(p, 1)}
                          className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#D8F3DC]"
                          style={{ borderColor: '#52B788', color: '#2D6A4F' }}
                        >
                          <Plus className="w-3 h-3" />
                        </button>
                      </div>
                      <div className="text-right text-sm font-medium" style={{ color: '#2C2C2A' }}>
                        R$ {fmtBR(p.preco)}
                      </div>
                      <div className="text-right text-sm" style={{ color: '#5F5E5A' }}>
                        {p.pv > 0 ? p.pv : '—'}
                      </div>
                      <div className="text-right text-sm font-bold" style={{ color: '#2D6A4F' }}>
                        R$ {fmtBR(subtotal)}
                      </div>
                      <div className="text-right text-sm font-semibold" style={{ color: '#52B788' }}>
                        {p.pv > 0 ? pvSubtotal : '—'}
                      </div>
                      <div className="flex justify-center">
                        <button
                          onClick={() => removerItem(p)}
                          className="p-1.5 rounded-full hover:bg-red-50 transition-colors"
                        >
                          <X className="w-4 h-4 text-red-500" />
                        </button>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </div>

      {/* Totais */}
      {itens.length > 0 && (
        <div
          className="rounded-xl p-5 space-y-2"
          style={{ backgroundColor: '#D8F3DC', border: '1px solid #52B788' }}
        >
          <div className="flex justify-between items-center">
            <span style={{ color: '#2C2C2A' }}>Total de PV</span>
            <span className="font-semibold" style={{ color: '#2D6A4F' }}>{totalPV}</span>
          </div>
          <div className="border-t pt-2 mt-1" style={{ borderColor: '#52B788' }}>
            <div className="flex justify-between items-center">
              <span className="text-lg font-semibold" style={{ color: '#2C2C2A' }}>Total dos produtos</span>
              <span className="text-xl font-bold" style={{ color: '#2D6A4F' }}>
                R$ {fmtBR(totalValor)}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Prévia do orçamento */}
      {itens.length > 0 && (
        <div className="rounded-xl border overflow-hidden" style={{ borderColor: '#EDE0D4' }}>
          <div
            className="px-4 py-2 text-xs font-semibold uppercase tracking-wide"
            style={{ backgroundColor: '#F8F4EF', color: '#B08968', borderBottom: '1px solid #EDE0D4' }}
          >
            Prévia do orçamento
          </div>
          <pre
            className="px-4 py-3 text-sm whitespace-pre-wrap font-mono"
            style={{ color: '#2C2C2A', backgroundColor: '#FFFFFF' }}
          >
            {montarOrcamento()}
          </pre>
        </div>
      )}

      {/* Botão copiar */}
      <div>
        <button
          onClick={copiarOrcamento}
          disabled={itens.length === 0}
          className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: '#2D6A4F', color: '#FFFFFF' }}
        >
          <Copy className="w-4 h-4" />
          Copiar orçamento para WhatsApp
        </button>
      </div>
    </div>
  )
}
